"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.brTagConverter = exports.linkConverter = exports.italicConverter = exports.boldConverter = exports.BR_REGEX = exports.ITALIC_REGEX = exports.BOLD_REGEX = exports.LINK_REGEX = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LINK_REGEX = exports.LINK_REGEX = new RegExp("((?:https?:\/\/)?(?:[\da-z\.-]+)\.(?:[a-z\.]{2,6})(?:[-a-zA-Z0-9@:%_\+.~#?&//=]*)*\/?)(?:\[(.+?)\])?/", "g");
var BOLD_REGEX = exports.BOLD_REGEX = new RegExp("\\*([\\w\\d\\s\\:\\/\\.\\[\\]]+)\\*", "g");
var ITALIC_REGEX = exports.ITALIC_REGEX = new RegExp("\\_([\\w\\d\\s\\:\\/\\.\\[\\]]+)\\_", "g");
var BR_REGEX = exports.BR_REGEX = new RegExp("<br\\/>", "g");

var boldConverter = exports.boldConverter = {
  regex: BOLD_REGEX,
  component: "span",
  props: {
    style: { fontWeight: "900" }
  },
  innerText: function innerText(matches) {
    return matches[1];
  }
};

var italicConverter = exports.italicConverter = {
  regex: ITALIC_REGEX,
  component: "span",
  props: {
    style: { fontStyle: "italic" }
  },
  innerText: function innerText(matches) {
    return matches[1];
  }
};

var linkConverter = exports.linkConverter = {
  regex: LINK_REGEX,
  component: "a",
  props: function props(_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        _ = _ref2[0],
        url = _ref2[1];

    return { href: url, targer: "_blank" };
  },
  innerText: function innerText(matches) {
    return matches[2] || matches[1];
  }
};

var brTagConverter = exports.brTagConverter = {
  regex: BR_REGEX,
  component: "br"
};

var Componentify = function (_Component) {
  _inherits(Componentify, _Component);

  function Componentify() {
    _classCallCheck(this, Componentify);

    return _possibleConstructorReturn(this, (Componentify.__proto__ || Object.getPrototypeOf(Componentify)).apply(this, arguments));
  }

  _createClass(Componentify, [{
    key: "getPlainTextComponent",
    value: function getPlainTextComponent(text, key) {
      var _props = this.props,
          plainTextComponent = _props.plainTextComponent,
          plainTextStyle = _props.plainTextStyle;


      return _react2.default.createElement(plainTextComponent, { key: key, style: plainTextStyle }, text);
    }
  }, {
    key: "getCurrentConverter",
    value: function getCurrentConverter(text) {
      var converters = this.props.converters;


      return converters.reduce(function (currtentConverter, converter) {
        // Clone so mutating doesn't affect client-passed objects
        converter = _extends({}, converter);
        var regex = new RegExp(converter.regex);

        if (!regex) {
          throw new Error("Invalid regex");
        }

        if (!regex.global) {
          throw new Error("Regex missing global flag");
        }

        var currentMatch = regex.exec(text);

        if (currentMatch !== null) {
          converter.match = currentMatch;
          var lowestIndex = currtentConverter && currtentConverter.match.index;
          var currentIndex = converter.match.index;

          if (currtentConverter === null || currentIndex < lowestIndex) {
            currtentConverter = converter;
          }
        }

        return currtentConverter;
      }, null);
    }
  }, {
    key: "generateComponent",
    value: function generateComponent(converter, key) {
      var component = converter.component,
          match = converter.match;
      var _converter$props = converter.props,
          props = _converter$props === undefined ? {} : _converter$props;
      var innerText = converter.innerText;

      var children = null;

      if (typeof props === "function") {
        props = props(match);
      }

      props.key = key;

      if (typeof innerText === "function") {
        innerText = innerText(match);
      }

      if (typeof innerText !== "undefined") {
        children = this.generateComponentList(innerText, match[0]);
      }

      return _react2.default.createElement(component, props, children);
    }
  }, {
    key: "generateComponentList",
    value: function generateComponentList(text, prevMatch) {
      var str = text;
      var components = [];

      while (str !== "") {
        var currtentConverter = this.getCurrentConverter(str);

        if (!currtentConverter || prevMatch === currtentConverter.match[0]) {
          break;
        }

        var matchIndex = currtentConverter.match.index;
        var textBeforeMatch = str.slice(0, matchIndex);
        var textAfterMatch = str.slice(matchIndex + currtentConverter.match[0].length);
        str = textAfterMatch;

        if (textBeforeMatch !== "") {
          components.push(this.getPlainTextComponent(textBeforeMatch, components.length.toString()));
        }

        components.push(this.generateComponent(currtentConverter, components.length.toString()));
      }

      if (str !== "") {
        if (prevMatch !== "") {
          components.push(str);
        } else {
          components.push(this.getPlainTextComponent(str, components.length.toString()));
        }
      }

      return components;
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          text = _props2.text,
          converters = _props2.converters;


      if (!text) {
        throw new Error('Missing property "text"');
      }

      if (!converters) {
        return this.getPlainTextComponent(text);
      }

      return this.generateComponentList(text, "");
    }
  }]);

  return Componentify;
}(_react.Component);

Componentify.defaultProps = {
  text: "",
  plainTextComponent: "span",
  converters: []
};
exports.default = Componentify;
